import {remove,find} from 'es-toolkit/compat';

export class Storage {

    //ローカルストレージ名
    static readonly KEY = 'salary_nav';
    static readonly MAX = 20;

    /*
    ローカルストレージ取得
     */
    public static getData(): any {
        const value = localStorage.getItem(this.KEY);
        if (value == null) {
            return {
                'history': [],
                'favorite': [],
            };
        }
        return JSON.parse(value);
    }

    //お気に入り追加
    public static addFavorite(company: any) {
        this.deleteFavorite(company.company_id);
        let data = this.getData();
        data.favorite.unshift(company);
        data.favorite = data.favorite.splice(0,this.MAX);
        this.save(data);
    }

    //お気に入り削除
    public static deleteFavorite(company_id: number) {
        let data = this.getData();
        remove(data.favorite, (c: any) => {
            return c.company_id == company_id;
        });
        this.save(data);
    }
    //お気に入り確認
    public static isFavorite(company_id: number) {
        const data = this.getData();
        const f = find(data.favorite,{company_id: company_id});
        if(typeof f === 'undefined'){
            return false;
        }
        return true;
    }

    //履歴追加
    public static addHistory(company: any) {
        this.deleteHistory(company.company_id);
        let data = this.getData();
        data.history.unshift(company);
        data.history = data.history.splice(0,this.MAX);
        this.save(data);
    }

    //履歴削除
    public static deleteHistory(compeny_id: number){
        let data = this.getData();
        remove(data.history, (c: any) => {
            return c.company_id == compeny_id;
        });
        this.save(data);
    }

    private static save(data) {
        localStorage.setItem(this.KEY, JSON.stringify(data));
    }

}